import { Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { UpdateModel } from '../models';
import { BaseRepository } from './base';
import { FactoryRepository } from './factory';

@Injectable({ providedIn: 'root' })
export class UpdateRepository extends BaseRepository<UpdateModel> {
  constructor(
    protected override readonly factoryRepository: FactoryRepository,
    protected override readonly apiService: ApiService
  ) {
    super(factoryRepository, apiService);
  }

  protected getModelName(): string {
    return 'UpdateFactory';
  }
}
